import getProductsPathByMemberIdAndFilterTypeSquadUtilSquadUtil from 'modules/squad/redux/utils/get-products-path-by-member-id-and-filter-type'
import getDataPathReduxUtil from 'modules/redux/utils/get-data-path'
import getReduxSelector from 'modules/redux/selectors/get'

const getMemberProductsByIdAndFilterTypeSquadSelector = (id, filterType) => state => {
  const path = getDataPathReduxUtil(
    getProductsPathByMemberIdAndFilterTypeSquadUtilSquadUtil(id, filterType)
  )
  return getReduxSelector(path)(state)
}

export default getMemberProductsByIdAndFilterTypeSquadSelector
